/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../common/graphql/types.generated';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetProductsFilter = {
  discount: boolean;
  freeShipping: boolean;
};

export type GetProductsSortFactor =
  | 'CREATED_AT'
  | 'NAME'
  | 'PRICE'
  | 'RECOMMENDED';

export type GetProductsQueryVariables = Exact<{
  limit: number;
  skip: number;
  sortOrder: number;
  category?: string | null | undefined;
  filter: Types.GetProductsFilter;
  sortFactor: Types.GetProductsSortFactor;
}>;


export type GetProductsQuery = { getProducts: Array<{ createdAt: string, id: string, name: string, price: number, quantity: number, slug: string, updatedAt: string, discountPercent: number | null, hidden: boolean, deletedAt: string | null, pictures: Array<{ large: string, small: string }> }> };

export const GetProductsDocument = gql`
    query getProducts($limit: Float!, $skip: Float!, $sortOrder: Float!, $category: String, $filter: GetProductsFilter!, $sortFactor: GetProductsSortFactor!) {
  getProducts(
    sortFactor: $sortFactor
    sortOrder: $sortOrder
    category: $category
    filter: $filter
    limit: $limit
    skip: $skip
  ) {
    createdAt
    id
    name
    pictures {
      large
      small
    }
    price
    quantity
    slug
    updatedAt
    discountPercent
    hidden
    deletedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductsGQL extends Apollo.Query<GetProductsQuery, GetProductsQueryVariables> {
    document = GetProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }